import API from './config'

export const ClientDataImportAPI = {

    /**
     * Análise prévia da importação: o que casa entre os dois clientes, o que precisa ser
     * criado e quantos saldos/movimentações viriam de cada ativo.
     * @param {number} sourceClientId cliente de origem
     * @param {number} targetClientId cliente de destino (clientOn)
     */
    async preview(sourceClientId, targetClientId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/client_data_import/preview', {
                source_client_id: sourceClientId,
                target_client_id: targetClientId,
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response ? error.response.data : { message: 'Falha de comunicação com o servidor' }
            };
        }

    },

    /**
     * Executa a importação. O backend roda tudo numa única transação: qualquer falha faz
     * ROLLBACK e nada é gravado no cliente de destino.
     * @param {object} data { sourceClientId, targetClientId, selectedFundAssetIds,
     *                        selectedTitleAssetIds, accountRegimeMap }
     */
    async execute(data) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/client_data_import/execute', {
                source_client_id: data.sourceClientId,
                target_client_id: data.targetClientId,
                selected_fund_asset_ids: data.selectedFundAssetIds,
                selected_title_asset_ids: data.selectedTitleAssetIds,
                account_regime_map: data.accountRegimeMap,
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response ? error.response.data : { message: 'Falha de comunicação com o servidor' }
            };
        }

    },

    /**
     * Análise prévia da sincronização do cadastro em migração com o cadastro oficial de onde
     * ele foi duplicado: o que entra por mês e por ativo, o que fica de fora e as divergências.
     * @param {number} targetClientId cadastro em migração (clientOn)
     * @param {string} [fromPeriod] MM/YYYY; sem ele o backend sugere o mês inicial
     */
    async syncPreview(targetClientId, fromPeriod) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/client_data_import/syncPreview', {
                target_client_id: targetClientId,
                from_period: fromPeriod,
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response ? error.response.data : { message: 'Falha de comunicação com o servidor' }
            };
        }

    },

    /**
     * Executa a sincronização numa única transação.
     * @param {object} data { targetClientId, fromPeriod, updateUntouchedBalances }
     */
    async syncExecute(data) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/client_data_import/syncExecute', {
                target_client_id: data.targetClientId,
                from_period: data.fromPeriod,
                update_untouched_balances: data.updateUntouchedBalances,
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response ? error.response.data : { message: 'Falha de comunicação com o servidor' }
            };
        }

    },

}
